/*
 * Main and demo navigation arrays
 */
import store from '../store/index'
var menus = [
  {
    name: 'Dashboard',
    to: '/backend/dashboard',
    icon: 'si si-speedometer',
    permission: "CAN_SEE_DASHBOARD"
  },
  {
    name: 'Roles',
    to: '/backend/tables/role',
    icon: 'si si-star',
    permission: "CAN_LIST_ROLE"
  },
  {
    name: 'Admin',
    to: '/backend/tables/admin',
    icon: 'si si-user',
    permission: "CAN_LIST_ADMIN"
  },
  {
    name: 'Categories',
    to: '/backend/tables/category',
    icon: 'si si-power',
    permission: "CAN_LIST_CATEGORY"
  },
  {
    name: 'Users List',
    to: '/backend/tables/user',
    icon: 'si si-users',
    permission: "CAN_LIST_USER"
  },
  {
    name: 'EBox List',
    to: '/backend/tables/ebox',
    icon: 'si si-users',
    permission: "CAN_LIST_USER"
  },
  {
    name: 'States',
    to: '/backend/tables/states',
    icon: 'si si-map',
    permission: "CAN_LIST_STATE"
  },
  {
    name: 'Banners',
    to: '/backend/tables/banners',
    icon: 'si si-picture',
    permission: "CAN_LIST_BANNER"
  },
  {
    name: 'Libraries',
    to: '/backend/tables/library',
    icon: 'si si-folder',
    permission: "CAN_LIST_LIBRARY"
  },
  {
    name: 'Video Sessions',
    to: '/backend/tables/video-sessions',
    icon: 'si si-target',
    permission: "CAN_LIST_VIDEO"
  },
  {
    name: 'Topics',
    to: '/backend/tables/topics',
    icon: 'si si-plane',
    permission: "CAN_LIST_TOPIC"
  },
  {
    name: 'Questions',
    to: '/backend/tables/questions',
    icon: 'si si-pin',
    permission: "CAN_LIST_QUESTION"
  },
  {
    name: 'Video',
    to: '/backend/tables/video',
    icon: 'si si-compass',
    permission: "CAN_LIST_VIDEO"
  },
  {
    name: 'Daily Challenge',
    to: '/backend/tables/daily-challenge',
    icon: 'si si-shuffle',
    permission: "CAN_LIST_DAILY_CHALLENGE"
  },
  {
    name: 'All India Mock Test',
    to: '/backend/tables/all-india-mock-test',
    icon: 'si si-anchor',
    permission: "CAN_LIST_ALL_INDIA_MOCK"
  },
  {
    name: 'Recruitment Drive Test',
    to: '/backend/tables/recruitment-drive-test',
    icon: 'si si-puzzle',
    permission: "CAN_LIST_ONGOING_RECRUITMENT"
  },
  {
    name: 'Upcomming Drives',
    to: '/backend/tables/upcomming-drives',
    icon: 'si si-calendar',
    permission: "CAN_LIST_UPCOMING_RECRUITMENT"
  },

  {
    name: 'Test Reports',
    to: '/backend/tables/test-reports',
    icon: 'si si-envelope',
    permission: "CAN_LIST_TEST_REPORT"
  },
  {
    name: 'Subscriptions',
    to: '/backend/tables/subscriptions',
    icon: 'si si-credit-card',
    permission: "CAN_LIST_SUBSCRIPTION"
  },
  {
    name: 'Discussions',
    to: '/backend/tables/discussions',
    icon: 'si si-share',
    permission: "CAN_LIST_DISCUSSION"
  },
  {
    name: 'Chats',
    to: '/backend/tables/chats',
    icon: 'si si-support',
    permission: "CAN_LIST_CHAT"
  },
  {
    name: 'Notifications',
    to: '/backend/tables/notifications',
    icon: 'si si-bell',
    permission: "CAN_LIST_NOTIFICATION"
  },
  {
    name: 'Colleges',
    to: '/backend/tables/colleges',
    icon: 'si si-pointer',
    permission: "CAN_LIST_COLLEGE"
  },

  {
    name: 'Help',
    to: '/backend/tables/help',
    icon: 'si si-tag',
    permission: "CAN_LIST_HELP"
  },
  {
    name: 'Feedbacks',
    to: '/backend/tables/feedbacks',
    icon: 'si si-envelope-open',
    permission: "CAN_LIST_FEEDBACK"
  },
  {
    name: 'App Version',
    to: '/backend/tables/appversions',
    icon: 'si si-flag',
    permission: "CAN_LIST_SW_VER"
  }
];
function getMenuList() {
  var user_permissions = store.getters.userDetails;
  return menus.filter(ele => user_permissions.includes(ele.permission));
}
const main = () => getMenuList();
export default main;
